import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

export interface IFetchFinSobSidePanelSettingsParameters {
  fYear: number
  partnerId: string
  programType: ProgramTypes
}

export const fetchFinSobSidePanelSettings = async ({
  fYear,
  partnerId,
  programType,
}: IFetchFinSobSidePanelSettingsParameters): Promise<{
  data: IFinSobSidePanelSetting[]
  programType: ProgramTypes
}> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPPlanningSideBarSettings/call`)

  if (fYear && partnerId && programType) {
    const payload = {
      'p.Fyear': fYear,
      'p.PartnerId': partnerId,
      'p.ProgramType': programType,
    }

    const {
      app: { ownerId },
    } = appGetState()

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      return { data: response.Data, programType }
    } catch (e) {
      Logger.error(e)
      return { data: [], programType }
    }
  }

  return { data: [], programType }
}
